import React from 'react';
import { useDraggable } from '@dnd-kit/core';
import styles from 'Components/PdfFormTemplates/PdfFormEditor/pdfFormEditor.module.css';
import { FIELD_TYPES } from '../types';

const FIELD_ICONS: Record<string, string> = {
  text: 'T',
  checkbox: '☑',
  date: '📅',
  signature: '✍',
  initial: 'I',
  email: '@',
  phone: '📞',
  number: '123',
};

function ToolboxItem({ type }: { type: string }) {
  const { attributes, listeners, setNodeRef, transform } = useDraggable({
    id: `toolbox-${type}`,
    data: { type: 'new-field', fieldType: type },
  });

  const style: React.CSSProperties = transform
    ? { transform: `translate(${transform.x}px, ${transform.y}px)`, zIndex: 1000 }
    : {};

  let label = type.charAt(0).toUpperCase() + type.slice(1);
  if (type === 'number') label = 'Number';
  if (type === 'initial') label = 'Initial';

  return (
    <div
      ref={setNodeRef}
      className={styles.toolboxItem}
      style={style}
      {...listeners} // eslint-disable-line react/jsx-props-no-spreading
      {...attributes} // eslint-disable-line react/jsx-props-no-spreading
    >
      <span className={styles.toolboxIcon}>{FIELD_ICONS[type]}</span>
      <span>
        {label}
        {' Field'}
      </span>
    </div>
  );
}

export function FieldToolbox({ hideHeader }: { hideHeader?: boolean }) {
  return (
    <div className={styles.toolboxSection}>
      {!hideHeader && <h3>Field Types</h3>}
      {FIELD_TYPES.map((type) => (
        <ToolboxItem key={type} type={type} />
      ))}
    </div>
  );
}
